import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
// material

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Moment from 'moment';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { format } from "date-fns";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { AccordionDetails, Select, TextareaAutosize, Autocomplete, Stack, Grid, Divider, TextField, FormControl, FormGroup, InputLabel, FormControlLabel, Checkbox, Modal, IconButton, Typography, Tooltip, MenuItem, Button, Box, CardMedia, Tabs, Tab, FormHelperText, FormLabel, Card, CardContent, InputAdornment } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import {
    LoadingButton,
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
} from '@mui/lab';
import { useSnackbar } from 'notistack';
import EditIcon from '@mui/icons-material/Edit';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ListIcon from '@mui/icons-material/List';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';

import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
// import IssueAllocationServicePage from '../../SidebarMenuComponents/ServiceComponent/IssueAllocationServicePage'
import ServiceEntryPage from "./ServiceEntryPage";
import ServiceCards from "../../Common/ServiceCard";
import TextAreaWithToolbar from '../../Common/TextAreaWithToolbar';


// -----------------------------------------------------------------------------------------------------
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#fbe9e7', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));
const TextAccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#FFF', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const serviceHistoryStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '85vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '100vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const AntTabs = styled(Tabs)({
    borderBottom: '1px solid #4e342e',
    position: 'sticky',
    '& .MuiTabs-indicator': {

    },
});
const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    fontsize: '20px',
    color: '#E7000B',
    Transition: '2s',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        color: '#4e342e',

        opacity: 1,
    },
    '&.Mui-selected': {
        color: '#4e342e',

        fontWeight: theme.typography.fontWeightMedium,

    },
    '&.Mui-focusVisible': {
        backgroundColor: '#fff',
    },
}));
const historyModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function StatusServicePage({
    showServiceEntry, handleShowServiceEntry, handleShowStatusIssue,
    expandedAccordion, setExpandedAccordion, handleStatusReset, hnadleIssueAllocationReset, fromEdit,

    // status
    value, handleChangeValue, handleShow, subStatus, selectedSubStatus, handleSubStatus,
    openModal, handleCloseModal, clientRemark, handleClientRemark, siteRemark, handleSiteRemark, clientSiteRemark, handleClientSiteRemark,
    handelOpenClick, openTrcakerDetailsModal, handeltrackerDetailsOpenClick, handleCloseTrackerDetailsModal, trackerDetailsColumn, trackerDetailsData,
    handleDeliveryTime, deliveryTime, handelCancelClick, handleStatusSave, forCancelConfirm, message, openModalForCancel, handleStatusCheckbox, isCheck,
    setOpenModalCancel, IsRCA, handleStatusRemarkSave, allocationReason, selectedAllocationReason, handleAllocationReason, handleSaveStatusClick, handleSaveStatusConfirm, openModalForSaveStatus,
    setOpenModalForSaveStatus,

    // Header
    handleTabObservationHistoryModal, tabObservationHistoryModal, handleTabObservationHistoryCloseModal,
    // issue allocation
    executive, selectedExecutive, handleExecutive, project, selectedProject, handleProject, handleAppointmentOpenModal,
    handleAppointemntCloseModal, openAppointmentModal, activity, selectedActivity, handleActivity, estimatedTime, handleEstimatedTime, appointmentDateTime,
    handleAppointmentDateTime, handleAppointmentSave, selectedDate, error, handleIssueAllocationRemark, remarkIssueAllocation, handleTentativeSupport, availableSlotsData,
    handleAppointmentTime, appointmentTime, availableSlotsDataColumn, showTentativeSupport, questionnaireModal, handleQuestionnaireOpenClick, handelQuestionnaireCancelClick,
    questionnaire, handleQuestionnaire, selectedQuestionnaire, questionnaireTxt, observationOpenModal, handleObservationModal, handleObservationCloseModal,
    handleObservationReasonDdl, observationReasonDdl, selectedObservationReasonDdl, handleObservationReason, observationReasonTxt, observationsolutionTxt, handleObservationSolution,
    handleObservationRecurring, observationRecurring, handleObservationOccurrence, observationOccurrence, handleObservationRcaDate, observationRcaDate, handleObservationRCASave,
    handleObservationRCAReset, handleObservationHistoryOpenClick, handleObservationHistoryCloseClick, observationHistoryModal, observationEditData, observationHistoryColumn, observationRCAHistoryColumn,
    setPageSize5, pageSize5, setOpenModalForSaveAllocation, openModalForSaveAllocation, handleSaveAllocationClick, handleSaveAllocationConfirm,
    setPageSize6, pageSize6,
    // Issue Allocation

    // service entry
    handleServiceDate, serviceDate, handleContactPerson, contactPerson, selectedContactPerson,
    contactDetails, handleContactDetails, handleServiceType, serviceType, selectedServiceType, timeType, setTimeType, reasonDdl, selectedReasonDdl, handleReasonDdl,
    handelReasonCancelClick, handelReasonOpenClick, reasonOpenModal, handleReason, solution, reasonTxt, handleSolution, recurring, handleRecurring, occurrence, handleOccurrence
    , rcaDate, handleRcaDate, handleRCAReset, handleRCASave, RecurringDropdown, statusRemark, ServiceEntries, handleInputChange, handleAddNewEntry, selectedServiceActivity,
    handleServiceActivity, serviceEntryRemark, handleServiceEntryRemark, activityTypeModal, handelActivityOpenClick, handelActivityCancelClick, activityTypeService, activityTypeServiceData,
    handelShowPreviousOpenClick, handelShowPreviousCancelClick, showPreviousServiceModal, showPreviousServiceData, showPreviousServiceColumn, issueAllocationHistoryColumn, handelIssueAllocationHistoryOpenClick,
    handelIssueAllocationHistoryCancelClick, issueAllocationHistoryData, issueAllocationHistoryOpenModal, saveServiceEntry, handleSelectFile, requestFile, removeFile, downloadUploadedFile, handleDrop, handleDragOver, handleDrgaDropClick,
    contactColumn, contactData, contactOpenModal, handleConatctOpenModal, handleContactCloseModal, handleIssueAllocationSave, disableDownloadBtn, handleBlur, pageSize, setPageSize, pageSize1, setPageSize1,
    pageSize2, setPageSize2, pageSize3, setPageSize3, pageSize4, setPageSize4, oldAptTime, newAptmtTime, loadData, handleServiceRemarkChange, handleTimeTypeChange, handleDeleteEntry,
    handleServiceReset, handleSaveServiceClick, handleSaveServiceConfirm, openModalForSaveService, setOpenModalForSaveService, handleDeleteServiceConfirm, setOpenModalForDeleteService,
    openModalForDeleteService, deleteIndex, setDeleteIndex, open, handleObservationClick, handleAddNew, handleAddNewCloseModal, handleHistory, handleHistoryClick, handleClose, anchorEl,
    observationHistoryOpenModal, observationAddModal, handleObsEntryDate, handleObsEntrySolution, handleObsEntryOccurrence, handleObsEntryReasonTxt, handleObsEntryRecurring, handleObsEntryReasonDdl,
    entryObsDate, entryObsReason, entryObsReasonDdl, entryObsReasonTxt, entryObsSolutionTxt, entryObsOccurrence, entryObsRecurring, handleObsEntryReset, handleObsEntrySave, entryObsEditData, obsEntryHistoryColumn, isShowToClient, handleCheckbox, isLoading, handelEditedServiceHistoryOpenClick, editedServiceHistory, expandTxt, setExpandTxt, downloadFile, fillInstallationNavigateClick, loading

}) {

    const CustomPagination = (props) => <GridPagination {...props} />;

    const combinedRemarks = `
  <p><strong>Client:</strong> ${clientRemark || ''}</p>
  </br>
  <p><strong>Site:</strong> ${siteRemark || ''}</p>
  </br>
  <p><strong>Client + Site:</strong> ${clientSiteRemark || ''}</p>
`;
    const dummyHistory = [
        { id: 1, date: '10 Dec 2025, 10:30', title: 'UI validation of Tiketic - issue analysis' },
        { id: 2, date: '09 Dec 2025, 09:15', title: 'Child issue popup fix' },
        { id: 3, date: '08 Dec 2025, 05:40', title: 'Edit issue popup changes' },
    ];
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingBottom: 0,
                    borderBottom: '1px solid #E5E7EB',
                    mt: '-4px'
                }}
            >
                {/* Left Section: Back Arrow + Tabs */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={handelCancelClick} size="small" sx={{ ml: '10px' }}>
                        <ArrowBackIosNewIcon fontSize="small" />
                    </IconButton>

                    <Tabs
                        value={showServiceEntry ? 1 : 0}
                        onChange={(e, newValue) => {
                            if (newValue === 0) handleShowStatusIssue();
                            else handleShowServiceEntry();
                        }}
                        sx={{ minHeight: '32px', mr: '10px' }}
                        TabIndicatorProps={{
                            style: { height: 3, backgroundColor: "#E7000B" }
                        }}
                    >
                        <Tab
                            label="Status & Issue Allocation"
                            sx={{
                                textTransform: 'none',
                                minHeight: '32px',
                                fontSize: '16px',
                                color: showServiceEntry ? '#B0A6A6' : '#E7000B',
                                fontWeight: showServiceEntry ? 500 : 600,
                                '&.Mui-selected': {
                                    color: '#E7000B !important',
                                    fontWeight: 600,
                                }
                            }}
                        />

                        <Tab
                            label="Service Entry"
                            sx={{
                                textTransform: 'none',
                                minHeight: '32px',
                                fontSize: '16px',
                                color: showServiceEntry ? '#E7000B' : '#B0A6A6',
                                fontWeight: showServiceEntry ? 600 : 500,
                                '&.Mui-selected': {
                                    color: '#E7000B !important',
                                    fontWeight: 600,
                                }
                            }}
                        />
                    </Tabs>
                </Box>

                {/* RIGHT SECTION BUTTONS */}
                <Box sx={{ display: "flex", gap: 1, ml: "auto", mr: 2 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Icon icon="material-symbols:article-person-outline" width={18} />}
                        sx={{
                            borderColor: '#A5D6A7',
                            color: '#2E7D32',
                            backgroundColor: '#F8FFF8',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: 12,
                            '&:hover': {
                                border: '1px solid #A5D6A7',
                                backgroundColor: '#F8FFF8',
                            },
                            height: 30,
                        }}
                        onClick={handleConatctOpenModal}
                    >
                        Contact
                    </Button>

                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Icon icon="material-symbols:history-rounded" width={18} />}
                        sx={{
                            borderColor: '#A5D6A7',
                            color: '#2E7D32',
                            backgroundColor: '#F8FFF8',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: 12,
                            '&:hover': {
                                border: '1px solid #A5D6A7',
                                backgroundColor: '#F8FFF8',
                            },
                            height: 30,
                        }}
                        onClick={handelShowPreviousOpenClick}
                    >
                        Service History
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Icon icon="material-symbols:history-rounded" width={18} />}
                        sx={{
                            borderColor: '#A5D6A7',
                            color: '#2E7D32',
                            backgroundColor: '#F8FFF8',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: 12,
                            '&:hover': {
                                border: '1px solid #A5D6A7',
                                backgroundColor: '#F8FFF8',
                            },
                            height: 30,
                        }}
                        onClick={handelIssueAllocationHistoryOpenClick}
                    >
                        Allocation History
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Icon icon="material-symbols:history-rounded" width={18} />}
                        sx={{
                            borderColor: '#A5D6A7',
                            color: '#2E7D32',
                            backgroundColor: '#F8FFF8',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: 12,
                            '&:hover': {
                                border: '1px solid #A5D6A7',
                                backgroundColor: '#F8FFF8',
                            },
                            height: 30,
                        }}
                        onClick={handleObservationHistoryOpenClick}
                    >
                        Observation History
                    </Button>
                    {/* Contact Modal */}
                    <Modal open={contactOpenModal} onClose={handleContactCloseModal}>
                        <Box sx={modalStyle}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '10px 16px',
                                    borderBottom: '1px solid #E0E0E0',
                                    backgroundColor: '#fff',
                                    m: 0, // remove outer margins
                                }}
                            >
                                <Typography variant="h6" fontWeight='bold'>
                                    Contact
                                </Typography>

                                <IconButton
                                    onClick={handleContactCloseModal}
                                    sx={{
                                        color: 'grey',
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>

                            <Box sx={{ height: '62vh', width: '100%' }}>
                                <DataGrid
                                    rows={contactData}
                                    columns={contactColumn}
                                    density="compact"
                                    getRowId={(row) => row.id || contactData.indexOf(row)}
                                    components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                    pagination
                                    paginationMode="client"
                                    rowsPerPageOptions={[25, 50, 100]}
                                    pageSize={pageSize3}
                                    onPageSizeChange={(newPageSize) => setPageSize3(newPageSize)}
                                    getRowHeight={() => 'auto'}
                                    sx={{
                                        '& .MuiDataGrid-iconSeparator': { display: 'none' },
                                        '& .MuiDataGrid-row:nth-of-type(even)': {
                                            backgroundColor: 'white',
                                        },
                                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                                            backgroundColor: '#f5f3f2',
                                            color: 'black',
                                        },
                                    }}
                                />
                            </Box>
                        </Box>
                    </Modal>

                    {/* Previous Service Modal */}
                    <Modal open={showPreviousServiceModal} onClose={handelShowPreviousCancelClick}>
                        <Box sx={serviceHistoryStyle}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    px: 2,
                                    py: 1,
                                    borderBottom: '1px solid #D1D5DB',
                                    backgroundColor: '#fff',
                                    m: 0, // remove outer margins
                                }}
                            >
                                <Typography variant="h6" fontWeight='600'>
                                    Service History
                                </Typography>

                                <IconButton
                                    onClick={handelShowPreviousCancelClick}
                                    sx={{
                                        width: 25,
                                        height: 25,
                                        backgroundColor: '#F1F1F1',
                                        borderRadius: '6px', // rounded square
                                        color: '#000',
                                        padding: 0,

                                    }}
                                >
                                    <CloseIcon sx={{ fontSize: 20 }} />
                                </IconButton>

                            </Box>

                             <Box sx={{ height: '62vh', width: '100%' }}> 
                               <DataGrid 
                                   rows={showPreviousServiceData} 
                                   columns={showPreviousServiceColumn} 
                                   density="compact" 
                                   getRowId={(row) => row.id || showPreviousServiceData.indexOf(row)} 
                                   components={{ Toolbar: GridToolbar, Pagination: CustomPagination }} 
                                   pagination 
                                   paginationMode="client" 
                                   rowsPerPageOptions={[25, 50, 100]} 
                                   pageSize={pageSize2} 
                                   onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)} 
                                   getRowHeight={() => 'auto'} 
                                   sx={{ 
                                       '& .MuiDataGrid-iconSeparator': { display: 'none' }, 
                                       '& .MuiDataGrid-row:nth-of-type(even)': { 
                                           backgroundColor: 'white', 
                                       }, 
                                       '& .MuiDataGrid-row:nth-of-type(odd)': { 
                                           backgroundColor: '#f5f3f2', 
                                           color: 'black', 
                                       }, 
                                   }} 
                               /> 
                                 </Box> 

                            {/* <Box*/}
                            {/*    sx={{*/}
                            {/*        display: 'flex',*/}
                            {/*        gap: 2,*/}
                            {/*        height: '428px',*/}
                            {/*        p: 1.5,*/}
                            {/*    }}*/}
                            {/* > */}
                            {/*    <Box sx={{ flex: 6, position: 'relative', display: 'flex' }}>*/}
                            {/*        <Card*/}
                            {/*            sx={{*/}
                            {/*                height: '405px',*/}
                            {/*                borderRadius: '15px',*/}
                            {/*                width: '100%',*/}
                            {/*                border: '1px solid #E5E5E5',*/}
                            {/*                boxShadow: 'none',*/}
                            {/*                display: 'flex',*/}
                            {/*                flexDirection: 'column',*/}
                            {/*                overflow: 'hidden',*/}
                            {/*            }}*/}
                            {/*        >*/}

                            {/*            <Box*/}
                            {/*                sx={{*/}
                            {/*                    display: 'flex',*/}
                            {/*                    alignItems: 'center',*/}
                            {/*                    gap: 2,*/}
                            {/*                    p: 1,*/}
                            {/*                    borderBottom: '1px solid #E5E5E5',*/}
                            {/*                    backgroundColor: '#fff',*/}
                            {/*                    height: '55px'*/}

                            {/*                }}*/}
                            {/*            >*/}
                            {/*                <Typography variant="h6" fontWeight="500">*/}
                            {/*                    Service History*/}
                            {/*                </Typography>*/}
                            {/*                <Box*/}
                            {/*                    sx={{*/}
                            {/*                        width: '50px',*/}
                            {/*                        height: '30px',*/}
                            {/*                        borderRadius: '8px',*/}
                            {/*                        boxShadow: '0px 0px 2px 0px #0000002E',*/}
                            {/*                        fontSize: '14px',*/}
                            {/*                        fontWeight: 400,*/}
                            {/*                        color: '#666060',*/}
                            {/*                        display: 'flex',*/}
                            {/*                        alignItems: 'center',*/}
                            {/*                        justifyContent: 'center',*/}
                            {/*                        background: '#FFFFFF',*/}
                            {/*                    }}*/}
                            {/*                >*/}
                            {/*                    {showPreviousServiceData?.length}*/}
                            {/*                </Box>*/}
                            {/*            </Box>*/}
                            {/*            <Box sx={{ p: 1, flex: 1, overflow: 'hidden' }}>*/}
                            {/*                {Array.isArray(showPreviousServiceData) && showPreviousServiceData.length > 0 ? (*/}

                            {/*                    <Box sx={{ height: '100%', overflowY: 'auto' }}>*/}
                            {/*                        <ServiceCards*/}
                            {/*                            serviceData={showPreviousServiceData}*/}
                            {/*                            handleClick={handelEditedServiceHistoryOpenClick}*/}
                            {/*                            downloadFile={downloadFile}*/}
                            {/*                            fillInstallationNavigateClick={fillInstallationNavigateClick}*/}
                            {/*                            variant="history"*/}
                            {/*                        />*/}
                            {/*                    </Box>*/}
                            {/*                ) : (*/}
                            {/*                    <Box*/}
                            {/*                        sx={{*/}
                            {/*                            height: '100%',*/}
                            {/*                            display: 'flex',*/}
                            {/*                            alignItems: 'center',*/}
                            {/*                            justifyContent: 'center',*/}
                            {/*                            flexDirection: 'column',*/}
                            {/*                            textAlign: 'center',*/}
                            {/*                        }}*/}
                            {/*                    >*/}
                            {/*                        <Typography sx={{ color: '#E7000B', fontSize: 16, fontWeight: '500' }}>*/}
                            {/*                            No Data Found*/}
                            {/*                        </Typography>*/}

                            {/*                    </Box>*/}
                            {/*                )}*/}
                            {/*            </Box>*/}
                            {/*        </Card>*/}
                            {/*    </Box>*/}
                            {/*    <Box sx={{ flex: 4, }}>*/}
                            {/*        <Card sx={{ p: 0, height: '405px', display: 'flex', flexDirection: 'column', border: '1px solid #E5E5E5', boxShadow: 'none' }}*/}
                            {/*        >*/}

                            {/*            <Box*/}
                            {/*                sx={{*/}
                            {/*                    display: 'flex',*/}
                            {/*                    justifyContent: 'space-between',*/}
                            {/*                    alignItems: 'center',*/}
                            {/*                    p: 1,*/}
                            {/*                    borderBottom: '1px solid #E5E5E5',*/}
                            {/*                    backgroundColor: '#fff',*/}
                            {/*                    height: '55px'*/}
                            {/*                }}*/}
                            {/*            >*/}
                            {/*                <Typography variant="h6" fontWeight="500">*/}
                            {/*                    Edited History*/}
                            {/*                </Typography>*/}


                            {/*            </Box>*/}
                            {/*            {Array.isArray(editedServiceHistory) && editedServiceHistory.length > 0 ? (*/}
                            {/*                <>*/}

                            {/*                    <Box*/}
                            {/*                        sx={{*/}
                            {/*                            p: 1.5,*/}
                            {/*                            pb: 1,*/}
                            {/*                            overflowY: "auto",*/}
                            {/*                            flex: 1,*/}
                            {/*                            position: 'relative',*/}
                            {/*                        }}*/}
                            {/*                    >*/}

                            {/*                        <Timeline*/}
                            {/*                            sx={{*/}
                            {/*                                p: 0,*/}
                            {/*                                m: 0,*/}
                            {/*                                alignItems: 'flex-start',*/}
                            {/*                                '& .MuiTimelineItem-root:before': {*/}
                            {/*                                    display: 'none',*/}
                            {/*                                },*/}
                            {/*                            }}*/}
                            {/*                        >*/}
                            {/*                            {Array.isArray(editedServiceHistory) && editedServiceHistory.map((history, index) => (*/}

                            {/*                                <TimelineItem sx={{ width: '100%', }} key={history.id || index}>*/}
                            {/*                                    <TimelineSeparator>*/}
                            {/*                                        <TimelineDot*/}
                            {/*                                            sx={{*/}
                            {/*                                                backgroundColor: '#2B7FFF',*/}
                            {/*                                                width: 10,*/}
                            {/*                                                height: 10,*/}
                            {/*                                                boxShadow: 'none',*/}
                            {/*                                                m: 0,*/}
                            {/*                                            }}*/}
                            {/*                                        />*/}
                            {/*                                        {index !== editedServiceHistory?.length - 1 && (*/}
                            {/*                                            <TimelineConnector*/}
                            {/*                                                sx={{*/}
                            {/*                                                    backgroundColor: '#B7C1D0',*/}
                            {/*                                                    width: '1px',*/}
                            {/*                                                    minHeight: 40,*/}
                            {/*                                                }}*/}
                            {/*                                            />*/}
                            {/*                                        )}*/}
                            {/*                                    </TimelineSeparator>*/}

                            {/*                                    <TimelineContent*/}
                            {/*                                        sx={{*/}
                            {/*                                            py: 0,*/}
                            {/*                                            px: 1,*/}
                            {/*                                            width: '100%',*/}
                            {/*                                            display: 'flex',*/}
                            {/*                                        }}*/}
                            {/*                                    >*/}

                            {/*                                        <Card*/}
                            {/*                                            sx={{*/}
                            {/*                                                borderRadius: '10px',*/}
                            {/*                                                boxShadow: 'none',*/}
                            {/*                                                mb: 2,*/}
                            {/*                                                width: '100%',*/}
                            {/*                                                alignSelf: 'stretch',*/}
                            {/*                                                border: index === 0 ? '1px solid #CAFADA' : '1px solid #E5E5E5',*/}
                            {/*                                                backgroundColor: index === 0 ? '#F0FDF4' : '#F9F9F9',*/}
                            {/*                                            }}*/}
                            {/*                                        >*/}

                            {/*                                            <Box*/}
                            {/*                                                display="flex"*/}
                            {/*                                                justifyContent="space-between"*/}
                            {/*                                                alignItems="flex-start"*/}
                            {/*                                                p={1}*/}
                            {/*                                                gap={1}*/}
                            {/*                                            >*/}
                            {/*                                                <Box sx={{ flex: 1, minWidth: 0 }}>*/}
                            {/*                                                    <Box*/}
                            {/*                                                        sx={{*/}
                            {/*                                                            display: 'flex',*/}
                            {/*                                                            justifyContent: 'space-between',*/}
                            {/*                                                            alignItems: 'center',*/}
                            {/*                                                            mb: 0.5,*/}
                            {/*                                                        }}*/}
                            {/*                                                    >*/}
                            {/*                                                        <Box*/}
                            {/*                                                            sx={{*/}
                            {/*                                                                display: 'flex',*/}
                            {/*                                                                alignItems: 'center',*/}
                            {/*                                                                gap: 0.5,*/}
                            {/*                                                                minWidth: 0, // important for ellipsis to work */}
                            {/*                                                                overflow: 'hidden',*/}
                            {/*                                                            }}*/}
                            {/*                                                        >*/}


                            {/*                                                            <Typography*/}
                            {/*                                                                sx={{*/}
                            {/*                                                                    fontWeight: 400,*/}
                            {/*                                                                    fontSize: 12,*/}
                            {/*                                                                    whiteSpace: 'nowrap',*/}
                            {/*                                                                    overflow: 'hidden',*/}
                            {/*                                                                    textOverflow: 'ellipsis',*/}
                            {/*                                                                    color: index === 0 ? "#717883" : "#ABA6A6"*/}
                            {/*                                                                }}*/}
                            {/*                                                            >*/}
                            {/*                                                                {history?.InsertedOn}*/}

                            {/*                                                            </Typography>*/}
                            {/*                                                        </Box>*/}
                            {/*                                                        {index === 0 && (*/}
                            {/*                                                            <Typography*/}
                            {/*                                                                sx={{*/}
                            {/*                                                                    fontWeight: 500,*/}
                            {/*                                                                    fontSize: 10,*/}
                            {/*                                                                    color: '#0B883E',*/}
                            {/*                                                                    flexShrink: 0,*/}
                            {/*                                                                    marginLeft: 1,*/}
                            {/*                                                                }}*/}
                            {/*                                                            >*/}
                            {/*                                                                Current*/}
                            {/*                                                            </Typography>*/}
                            {/*                                                        )}*/}
                            {/*                                                    </Box>*/}

                            {/*                                                    <Typography sx={{*/}
                            {/*                                                        fontSize: 12,*/}
                            {/*                                                        wordBreak: 'break-word',*/}
                            {/*                                                        color: index === 0 ? "#121212" : "#717883"*/}

                            {/*                                                    }}>*/}
                            {/*                                                        <span*/}
                            {/*                                                            dangerouslySetInnerHTML={{*/}
                            {/*                                                                __html: (*/}
                            {/*                                                                    expandTxt.includes(history.Id)*/}
                            {/*                                                                        ? (history?.Newvalue || "")*/}
                            {/*                                                                        : (history?.Newvalue || "").substring(0, 165)*/}
                            {/*                                                                ).replace(/\n/g, "<br/>"),*/}
                            {/*                                                            }}*/}
                            {/*                                                        />*/}

                            {/*                                                        {(history?.Newvalue || "").length > 165 && (*/}
                            {/*                                                            <Box*/}
                            {/*                                                                component="span"*/}

                            {/*                                                                onClick={(e) => {*/}
                            {/*                                                                    e.stopPropagation();*/}
                            {/*                                                                    setExpandTxt((prev) =>*/}
                            {/*                                                                        prev.includes(history?.Id)*/}
                            {/*                                                                            ? prev.filter((id) => id !== history?.Id)*/}
                            {/*                                                                            : [...prev, history?.Id]*/}
                            {/*                                                                    );*/}
                            {/*                                                                }}*/}
                            {/*                                                                sx={{*/}
                            {/*                                                                    color: "#155DFC",*/}
                            {/*                                                                    fontWeight: 400,*/}
                            {/*                                                                    cursor: "pointer",*/}
                            {/*                                                                    ml: 0.5,*/}
                            {/*                                                                }}*/}
                            {/*                                                            >*/}
                            {/*                                                                {expandTxt.includes(history?.Id)*/}

                            {/*                                                                    ? " Read Less"*/}
                            {/*                                                                    : " Read More.."}*/}
                            {/*                                                            </Box>*/}
                            {/*                                                        )}*/}
                            {/*                                                    </Typography>*/}

                            {/*                                                </Box>*/}
                            {/*                                            </Box>*/}
                            {/*                                        </Card>*/}
                            {/*                                    </TimelineContent>*/}
                            {/*                                </TimelineItem>*/}
                            {/*                            ))}*/}
                            {/*                        </Timeline >*/}
                            {/*                    </Box>*/}

                            {/*                </>*/}
                            {/*            ) : (*/}
                            {/*                <Box*/}
                            {/*                    sx={{*/}
                            {/*                        flex: 1,*/}
                            {/*                        display: 'flex',*/}
                            {/*                        flexDirection: 'column',*/}
                            {/*                        justifyContent: 'center',*/}
                            {/*                        alignItems: 'center',*/}
                            {/*                        textAlign: 'center',*/}
                            {/*                        px: 2,*/}
                            {/*                    }}*/}
                            {/*                >*/}
                            {/*                    <Typography sx={{ color: '#928A8A', fontWeight: 500, fontSize: 16 }}>*/}
                            {/*                        Service not selected*/}
                            {/*                    </Typography>*/}

                            {/*                    <Typography sx={{ color: '#928A8A', fontWeight: 400, fontSize: 12 }}>*/}
                            {/*                        Select a service entry to view its edit history. Edit history is*/}
                            {/*                        available only for entries marked with the (*/}
                            {/*                        <Box*/}
                            {/*                            component="span"*/}
                            {/*                            sx={{*/}
                            {/*                                display: 'inline-flex',*/}
                            {/*                                alignItems: 'center',*/}
                            {/*                                verticalAlign: 'middle',*/}
                            {/*                                lineHeight: 1,*/}
                            {/*                                mx: 0.5,*/}
                            {/*                            }}*/}
                            {/*                        >*/}
                            {/*                            <HistoryToggleOffOutlinedIcon*/}
                            {/*                                sx={{ fontSize: 14, verticalAlign: 'middle', color: '#1E5DB6' }}*/}
                            {/*                            />*/}
                            {/*                        </Box>*/}
                            {/*                        ) edit icon*/}
                            {/*                    </Typography>*/}
                            {/*                </Box>*/}
                            {/*            )}*/}

                            {/*        </Card>*/}
                            {/*    </Box>*/}
                            {/* </Box>*/}

                        </Box>
                    </Modal>

                    {/* Allocation History Modal */}
                    <Modal open={issueAllocationHistoryOpenModal} onClose={handelIssueAllocationHistoryCancelClick}>
                        <Box sx={historyModalStyle}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '10px 16px',
                                    borderBottom: '1px solid #E0E0E0',
                                    backgroundColor: '#fff',
                                    m: 0, // remove outer margins
                                }}
                            >
                                <Typography variant="h6" fontWeight='bold'>
                                    Issue Allocation History
                                </Typography>

                                <IconButton
                                    onClick={handelIssueAllocationHistoryCancelClick}
                                    sx={{
                                        color: 'grey',
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>

                            <div style={{ height: '62vh', width: '100%' }}>
                                <DataGrid
                                    rows={issueAllocationHistoryData}
                                    columns={issueAllocationHistoryColumn}
                                    density="compact"
                                    getRowId={(row) => row.id || issueAllocationHistoryData.indexOf(row)}
                                    components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                    pagination
                                    paginationMode="client"
                                    rowsPerPageOptions={[25, 50, 100]}
                                    pageSize={pageSize}
                                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                    getRowHeight={() => 'auto'}
                                    sx={{

                                        '& .MuiDataGrid-iconSeparator': {
                                            display: "none", // Removes the separator
                                        },
                                        '& .MuiDataGrid-row:nth-of-type(even)': {
                                            backgroundColor: 'white', // Even rows: White
                                        },
                                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                                            backgroundColor: '#f5f3f2', // Odd rows: Blue
                                            color: 'bleck', // Set text color to white for better contrast
                                        },
                                        "& .MuiDataGrid-columnHeader": {
                                            alignItems: "flex-start"            // text sticks to the top
                                        },
                                        "& .MuiDataGrid-columnHeaderTitleContainer": {
                                            justifyContent: "flex-start"        // …and to the left
                                        },
                                        "& .MuiDataGrid-columnHeaderTitle": {
                                            whiteSpace: "normal !important",    // allow line breaks
                                            wordBreak: "break-word",
                                            lineHeight: 1.2
                                        },
                                    }}

                                />
                            </div>

                        </Box>
                    </Modal>


                    <Modal open={observationHistoryModal} onClose={handleObservationHistoryCloseClick}>
                        <Box sx={historyModalStyle}>

                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '10px 16px',
                                    borderBottom: '1px solid #E0E0E0',
                                    backgroundColor: '#fff',
                                    m: 0, // remove outer margins
                                }}
                            >
                                <Typography variant="h6" fontWeight='bold'>
                                    Observation  History
                                </Typography>

                                <IconButton
                                    onClick={handleObservationHistoryCloseClick}
                                    sx={{
                                        color: 'grey',
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>

                            <Typography variant="body2" pl={2} mt={1}>
                                <Box component="span" fontWeight="bold">Client:</Box>{' '}
                                <Box component="span" fontStyle="italic">{loadData.ClientName}</Box>,{' '}
                                <Box component="span" fontWeight="bold">Site:</Box>{' '}
                                <Box component="span" fontStyle="italic">{loadData.Site}</Box>,{' '}
                                <Box component="span" fontWeight="bold">IssueId:</Box>{' '}
                                <Box component="span" fontStyle="italic">{loadData.Id}</Box>
                            </Typography>
                            <div style={{ height: '62vh', width: '100%', }}>
                                <DataGrid
                                    rows={observationEditData}
                                    columns={observationHistoryColumn}
                                    density="compact"
                                    getRowId={(row) => row.id || observationEditData.indexOf(row)}
                                    components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                    pagination
                                    paginationMode="client"
                                    rowsPerPageOptions={[25, 50, 100]}
                                    pageSize={pageSize5}
                                    onPageSizeChange={(newPageSize) => setPageSize5(newPageSize)}
                                    getRowHeight={() => 'auto'}
                                    getRowClassName={(params) =>
                                        params.row.Type === 'RCA' ? 'rca-row' : 'default-row'
                                    }
                                    sx={{
                                        '& .MuiDataGrid-iconSeparator': {
                                            display: 'none',
                                        },
                                        '& .rca-row': {
                                            backgroundColor: '#f5f3f2',
                                        },
                                        '& .default-row': {
                                            backgroundColor: '#ffffff',
                                        },
                                    }}


                                />
                            </div>

                        </Box>
                    </Modal>

                    <Modal open={observationOpenModal} onClose={handleObservationCloseModal}>
                        <Box sx={{
                            ...modalStyle,
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '90vh',
                            overflow: 'hidden',
                        }}>
                            <Box
                                sx={{
                                    position: 'sticky',
                                    top: 0,
                                    backgroundColor: '#fff',
                                    zIndex: 1,
                                    borderBottom: '1px solid #E5E5E5',


                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 16px',
                                        borderBottom: '1px solid #E0E0E0',
                                        backgroundColor: '#fff',
                                        m: 0, // remove outer margins
                                    }}
                                >
                                    <Typography variant="h6" color="text.primary" fontWeight="bold">
                                        Observation
                                    </Typography>
                                    <IconButton onClick={handleObservationCloseModal}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    overflowY: 'auto',
                                    pt: 2,
                                    px: 2,
                                }}
                            >
                                <Stack spacing={1}>

                                    <Stack direction="row" spacing={2}>
                                        <FormControl size="small" fullWidth>
                                            <FormLabel >Observation Date</FormLabel>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker

                                                    inputFormat="dd/MMM/yyyy"
                                                    value={observationRcaDate}
                                                    onChange={handleObservationRcaDate}
                                                    renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                        <FormControl size="small" fullWidth>
                                            <FormLabel >Observation Reason</FormLabel>
                                            <Autocomplete
                                                fullWidth

                                                size="small"
                                                id="observationreason"
                                                value={selectedObservationReasonDdl.find((option) => option.id === observationReasonDdl) || ""}
                                                onChange={(_, newValue) => handleObservationReasonDdl(newValue)}
                                                options={selectedObservationReasonDdl}
                                                getOptionLabel={(option) => option.Description || ""}
                                                renderInput={(params) => <TextField {...params} placeholder="Select Reason" />}
                                                limitTags={2}
                                            />

                                        </FormControl>
                                    </Stack>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Observation Reason Details</FormLabel>
                                        <TextareaAutosize
                                            minRows={3}
                                            placeholder="Describe the situation that led to the observation..."
                                            value={observationReasonTxt}
                                            onChange={handleObservationReason}
                                            style={{
                                                width: '100%',
                                                resize: 'none',
                                                fontFamily: 'sans-serif',
                                                border: '1px solid #E5E5E5',
                                                borderRadius: '4px',
                                                padding: '12px',
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Observation Solution</FormLabel>
                                        <TextareaAutosize
                                            minRows={3}
                                            placeholder="Describe proposed solution..."
                                            value={observationsolutionTxt}
                                            onChange={handleObservationSolution}
                                            style={{
                                                width: '100%',
                                                resize: 'none',
                                                fontFamily: 'sans-serif',
                                                border: '1px solid #E5E5E5',
                                                borderRadius: '4px',
                                                padding: '12px',
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Recurring</FormLabel>
                                        <Select
                                            value={observationRecurring}
                                            onChange={(e) => handleObservationRecurring(e.target.value)}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        maxHeight: 200,
                                                    },
                                                },
                                            }}
                                        >
                                            {RecurringDropdown.map((reason) => (
                                                <MenuItem key={reason.Id} value={reason.Id}>
                                                    {reason.value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Occurrence</FormLabel>
                                        <TextareaAutosize
                                            minRows={1}
                                            placeholder="Mention how often this issue occurs..."
                                            value={observationOccurrence}
                                            onChange={handleObservationOccurrence}
                                            style={{
                                                flexGrow: 1,
                                                resize: 'none',
                                                fontFamily: 'sans-serif',
                                                border: '1px solid #E5E5E5',
                                                borderRadius: '4px',
                                                padding: '12px',
                                            }}
                                        />
                                    </FormControl>
                                </Stack>
                            </Box>
                            {/* Reset & Save Buttons */}
                            <Box
                                sx={{
                                    position: 'sticky',
                                    bottom: 0,
                                    backgroundColor: '#fff',

                                    mt: 2,
                                    p: 2,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: 2,
                                }}
                            >

                                <Button variant="outlined" color="inherit" onClick={handleObservationRCAReset}>
                                    Reset
                                </Button>
                                <Button
                                    size="medium"
                                    type="submit"
                                    variant="contained"
                                    onClick={handleObservationRCASave}
                                >
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                </Box>
            </Box>



            {showServiceEntry ? (
                <ServiceEntryPage
                    handleServiceDate={handleServiceDate} serviceDate={serviceDate} handleContactPerson={handleContactPerson} contactPerson={contactPerson}
                    selectedContactPerson={selectedContactPerson} contactDetails={contactDetails} handleContactDetails={handleContactDetails}
                    handleServiceType={handleServiceType} serviceType={serviceType} selectedServiceType={selectedServiceType} timeType={timeType} setTimeType={setTimeType}
                    selectedServiceActivity={selectedServiceActivity} handleServiceActivity={handleServiceActivity}
                    ServiceEntries={ServiceEntries} handleInputChange={handleInputChange} handleAddNewEntry={handleAddNewEntry} serviceEntryRemark={serviceEntryRemark}
                    handleServiceEntryRemark={handleServiceEntryRemark} activityTypeModal={activityTypeModal} handelActivityOpenClick={handelActivityOpenClick}
                    handelActivityCancelClick={handelActivityCancelClick} activityTypeService={activityTypeService} activityTypeServiceData={activityTypeServiceData}
                    handelShowPreviousOpenClick={handelShowPreviousOpenClick} handelShowPreviousCancelClick={handelShowPreviousCancelClick} showPreviousServiceModal={showPreviousServiceModal}
                    showPreviousServiceData={showPreviousServiceData} showPreviousServiceColumn={showPreviousServiceColumn} issueAllocationHistoryColumn={issueAllocationHistoryColumn}
                    handelIssueAllocationHistoryOpenClick={handelIssueAllocationHistoryOpenClick} handelIssueAllocationHistoryCancelClick={handelIssueAllocationHistoryCancelClick}
                    issueAllocationHistoryData={issueAllocationHistoryData} issueAllocationHistoryOpenModal={issueAllocationHistoryOpenModal} saveServiceEntry={saveServiceEntry}
                    reasonDdl={reasonDdl} selectedReasonDdl={selectedReasonDdl} handleReasonDdl={handleReasonDdl}
                    handelReasonCancelClick={handelReasonCancelClick} handelReasonOpenClick={handelReasonOpenClick} reasonOpenModal={reasonOpenModal} reasonTxt={reasonTxt} handleReason={handleReason} solution={solution} handleSolution={handleSolution}
                    recurring={recurring} handleRecurring={handleRecurring} occurrence={occurrence} handleOccurrence={handleOccurrence} rcaDate={rcaDate} handleRcaDate={handleRcaDate} handleRCAReset={handleRCAReset} handleRCASave={handleRCASave} RecurringDropdown={RecurringDropdown}
                    statusRemark={statusRemark} IsRCA={IsRCA} handleSelectFile={handleSelectFile} requestFile={requestFile} removeFile={removeFile} forCancelConfirm={forCancelConfirm} message={message} handleDrop={handleDrop} handleDragOver={handleDragOver} handleDrgaDropClick={handleDrgaDropClick}
                    openModalForCancel={openModalForCancel} setOpenModalCancel={setOpenModalCancel} handelCancelClick={handelCancelClick} downloadUploadedFile={downloadUploadedFile} contactColumn={contactColumn} contactData={contactData}
                    contactOpenModal={contactOpenModal} handleConatctOpenModal={handleConatctOpenModal} handleContactCloseModal={handleContactCloseModal} disableDownloadBtn={disableDownloadBtn} handleBlur={handleBlur} pageSize={pageSize} setPageSize={setPageSize}
                    pageSize2={pageSize2} setPageSize2={setPageSize2} pageSize3={pageSize3} setPageSize3={setPageSize3} pageSize4={pageSize4} setPageSize4={setPageSize4} handleServiceRemarkChange={handleServiceRemarkChange} handleTimeTypeChange={handleTimeTypeChange} expandedAccordion={expandedAccordion} setExpandedAccordion={setExpandedAccordion} handleDeleteEntry={handleDeleteEntry} handleServiceReset={handleServiceReset} handleSaveServiceClick={handleSaveServiceClick} handleSaveServiceConfirm={handleSaveServiceConfirm}
                    openModalForSaveService={openModalForSaveService} setOpenModalForSaveService={setOpenModalForSaveService} handleDeleteServiceConfirm={handleDeleteServiceConfirm}
                    setOpenModalForDeleteService={setOpenModalForDeleteService} openModalForDeleteService={openModalForDeleteService} deleteIndex={deleteIndex} setDeleteIndex={setDeleteIndex}
                    open={open} handleObservationClick={handleObservationClick} handleAddNew={handleAddNew}
                    handleAddNewCloseModal={handleAddNewCloseModal} handleHistory={handleHistory} handleHistoryClick={handleHistoryClick} handleClose={handleClose} anchorEl={anchorEl}
                    observationHistoryOpenModal={observationHistoryOpenModal} observationAddModal={observationAddModal} loadData={loadData} observationEditData={observationEditData} observationHistoryColumn={observationHistoryColumn} setPageSize5={setPageSize5} pageSize5={pageSize5} handleObservationReasonDdl={handleObservationReasonDdl} observationReasonDdl={observationReasonDdl} selectedObservationReasonDdl={selectedObservationReasonDdl} handleObservationReason={handleObservationReason}
                    observationReasonTxt={observationReasonTxt} observationsolutionTxt={observationsolutionTxt} handleObservationSolution={handleObservationSolution} handleObservationRecurring={handleObservationRecurring} observationRecurring={observationRecurring} handleObservationOccurrence={handleObservationOccurrence}
                    observationOccurrence={observationOccurrence} handleObservationRcaDate={handleObservationRcaDate} observationRcaDate={observationRcaDate} handleObservationRCASave={handleObservationRCASave} handleObservationRCAReset={handleObservationRCAReset}

                    handleObsEntryDate={handleObsEntryDate} handleObsEntrySolution={handleObsEntrySolution} handleObsEntryOccurrence={handleObsEntryOccurrence} handleObsEntryReasonTxt={handleObsEntryReasonTxt} handleObsEntryRecurring={handleObsEntryRecurring} handleObsEntryReasonDdl={handleObsEntryReasonDdl}

                    entryObsDate={entryObsDate} entryObsReason={entryObsReason} entryObsReasonDdl={entryObsReasonDdl} entryObsReasonTxt={entryObsReasonTxt} entryObsSolutionTxt={entryObsSolutionTxt} entryObsOccurrence={entryObsOccurrence} entryObsRecurring={entryObsRecurring} handleObsEntryReset={handleObsEntryReset} handleObsEntrySave={handleObsEntrySave} entryObsEditData={entryObsEditData} obsEntryHistoryColumn={obsEntryHistoryColumn} handleObservationHistoryOpenClick={handleObservationHistoryOpenClick} handleObservationModal={handleObservationModal} isShowToClient={isShowToClient} handleCheckbox={handleCheckbox} isLoading={isLoading} fromEdit={fromEdit}

                />

            ) : (
                <Grid container spacing={2} mx={0} mt={0.2} sx={{ overflowX: "hidden", margin: 0, width: "100%" }} >
                    {/* Left Side - 50% */}
                    <Grid item xs={12} sm={5.9}>
                        <Box
                            sx={{
                                height: '78vh',
                                display: 'flex',
                                flexDirection: 'column',
                                border: "1px solid #E5E5E5",
                                borderRadius: "8px",
                                overflow: 'hidden', // hide scrollbars from main box
                                backgroundColor: '#FFFFFF',

                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    overflowY: 'auto',
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        position: 'sticky',
                                        zIndex: 10,
                                        top: 0,
                                        px: 2,
                                        py: 1.5,
                                        backgroundColor: '#FFFFFF',
                                    }}
                                >
                                    <Icon
                                        icon="material-symbols:pace"
                                        width={20}
                                        height={20}
                                        color="#4A5565"
                                        style={{ marginRight: 8 }}
                                    />
                                    <Typography variant="body2" sx={{ fontSize: 14, color: '#121212', fontWeight: 600 }}>
                                        Status
                                    </Typography>
                                </Box>
                                <Box sx={{ px: 2, pb: 2 }}>
                                    <Stack spacing={1}>
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Box>
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {loadData?.ClientName} {loadData?.Site ? `(${loadData?.Site})` : ''}
                                                </Typography>
                                                <Typography variant="body1">
                                                    Issue ID: <Box component="span" sx={{ color: '#F74949', fontWeight: 500 }}>{loadData?.Id}</Box>
                                                </Typography>
                                            </Box>
                                            <Button
                                                size="medium"
                                                type="submit"
                                                variant="contained"
                                                sx={{
                                                    color: "white",
                                                    bgcolor: IsRCA ? "green" : "#E44D4D",
                                                    fontSize: '12px',
                                                    height: 22,
                                                    width: 43,
                                                    borderRadius: '7px',
                                                    '&:hover': {
                                                        border: IsRCA ? '1px solid green' : '1px solid #E44D4D',
                                                        backgroundColor: IsRCA ? "green" : "#E44D4D",
                                                    },
                                                }}
                                                onClick={handelReasonOpenClick}
                                            >
                                                RCA
                                            </Button>
                                        </Box>
                                        <Modal open={reasonOpenModal} onClose={handelReasonCancelClick}>
                                            <Box sx={{
                                                ...historyModalStyle,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                maxHeight: '90vh',
                                                overflow: 'hidden',
                                            }}>
                                                {/* Sticky Header */}
                                                <Box
                                                    sx={{
                                                        position: 'sticky',
                                                        top: 0,
                                                        backgroundColor: '#fff',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            padding: '0px 16px',
                                                            borderBottom: '1px solid #E0E0E0',
                                                            backgroundColor: '#fff',
                                                            m: 0, // remove outer margins
                                                        }}
                                                    >
                                                        <Typography variant="h6" color="text.primary" fontWeight="bold">
                                                            Issue RCA
                                                        </Typography>
                                                        <IconButton onClick={handelReasonCancelClick}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Box>
                                                    <Divider />
                                                </Box>

                                                {/* Scrollable Content */}
                                                <Box
                                                    sx={{
                                                        flex: 1,
                                                        overflow: 'hidden',
                                                        display: 'flex',

                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "30%",
                                                            backgroundColor: "#fff",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            borderRight: "1px solid #E0E0E0",
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                flex: 1,
                                                                overflowY: "auto",
                                                                p: 2,
                                                            }}
                                                        >
                                                            <Stack spacing={1}>

                                                                {/* RCA Date */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>RCA Date</FormLabel>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            inputFormat="dd/MMM/yyyy"
                                                                            value={rcaDate}
                                                                            onChange={handleRcaDate}
                                                                            renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </FormControl>

                                                                {/* RCA Reason Dropdown */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>Issue RCA Reason</FormLabel>
                                                                    <Autocomplete
                                                                        fullWidth

                                                                        size="small"
                                                                        id="rcareason"
                                                                        value={selectedReasonDdl.find((option) => option.id === reasonDdl) || ""}
                                                                        onChange={(_, newValue) => handleReasonDdl(newValue)}
                                                                        options={selectedReasonDdl}
                                                                        getOptionLabel={(option) => option.Description || ""}
                                                                        renderInput={(params) => <TextField {...params}
                                                                            placeholder="Select Reason" />}
                                                                        limitTags={2}
                                                                    />

                                                                </FormControl>

                                                                {/* RCA Reason Details */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>Issue RCA Reason Details</FormLabel>
                                                                    <TextareaAutosize
                                                                        minRows={3}
                                                                        placeholder="Describe the events or conditions that directly caused this                                         issue..."
                                                                        value={reasonTxt}
                                                                        onChange={handleReason}
                                                                        style={{
                                                                            width: "100%",
                                                                            resize: "none",

                                                                            border: "1px solid #E5E5E5",
                                                                            borderRadius: "4px",
                                                                            padding: "8px",
                                                                        }}
                                                                    />
                                                                </FormControl>

                                                                {/* RCA Solution */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>Issue RCA Solution</FormLabel>
                                                                    <TextareaAutosize
                                                                        minRows={3}
                                                                        placeholder="Describe proposed solution…"
                                                                        value={solution}
                                                                        onChange={handleSolution}
                                                                        style={{
                                                                            width: "100%",
                                                                            resize: "none",

                                                                            border: "1px solid #E5E5E5",
                                                                            borderRadius: "4px",
                                                                            padding: "8px",
                                                                        }}
                                                                    />
                                                                </FormControl>

                                                                {/* Recurring */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>Recurring</FormLabel>
                                                                    <Select
                                                                        size="small"
                                                                        value={recurring}
                                                                        onChange={(e) => handleRecurring(e.target.value)}
                                                                        MenuProps={{
                                                                            PaperProps: {
                                                                                sx: {
                                                                                    backgroundColor: '#fbe9e7',
                                                                                    maxHeight: '200px',
                                                                                    width: '200px',
                                                                                },
                                                                            },
                                                                        }}
                                                                    >
                                                                        {RecurringDropdown.map((reason) => (
                                                                            <MenuItem key={reason.Id} value={reason.Id}>
                                                                                {reason.value}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>

                                                                {/* Occurrence */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>Occurrence</FormLabel>
                                                                    <TextareaAutosize
                                                                        minRows={3}
                                                                        placeholder="Mention how often this issue occurs..."
                                                                        value={occurrence}
                                                                        onChange={handleOccurrence}
                                                                        style={{
                                                                            width: "100%",
                                                                            resize: "none",

                                                                            border: "1px solid #E5E5E5",
                                                                            borderRadius: "4px",
                                                                            padding: "8px",
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                            </Stack>
                                                        </Box>
                                                        <Box sx={{
                                                            borderTop: "1px solid #D1D5DB",
                                                            backgroundColor: "#fff",
                                                            p: 2,

                                                        }}>

                                                            <Stack direction="row" spacing={1} justifyContent="space-between">
                                                                <Tooltip title="Reset">

                                                                    <Button variant="outlined" sx={{ width: '152px', height: '40px', color: '#374151' }} onClick={handleRCAReset}>Reset</Button>
                                                                </Tooltip >

                                                                <Tooltip title="Save">
                                                                    <Button variant="contained" sx={{ width: '152px', height: '40px' }} onClick={handleRCASave} >Save</Button>
                                                                </Tooltip >
                                                            </Stack>
                                                        </Box>

                                                    </Box>

                                                    <Box
                                                        sx={{
                                                            flex: 1,
                                                            overflowY: "auto",
                                                            p: 2,
                                                        }}
                                                    >
                                                        <Typography variant="h6" fontWeight='bold'>
                                                            Observation History
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                flexWrap: 'wrap',
                                                                gap: 2, // small uniform gap between sections
                                                                mt: 1,
                                                            }}
                                                        >
                                                            <Box>
                                                                <Box component="span" fontWeight="bold">Client:</Box>{' '}
                                                                <Box component="span">{loadData?.ClientName}</Box>
                                                            </Box>

                                                            <Box>
                                                                <Box component="span" fontWeight="bold">Site:</Box>{' '}
                                                                <Box component="span">{loadData?.Site}</Box>
                                                            </Box>

                                                            <Box>
                                                                <Box component="span" fontWeight="bold">Issue ID:</Box>{' '}
                                                                <Box component="span">{loadData?.Id}</Box>
                                                            </Box>
                                                        </Box>


                                                        <div style={{ height: '69vh', width: '100%', }}>
                                                            <DataGrid
                                                                rows={
                                                                    Array.isArray(observationEditData)
                                                                        ? observationEditData.filter((row) => row?.Type === 'Observation')
                                                                        : []
                                                                }
                                                                columns={observationRCAHistoryColumn}
                                                                density="compact"
                                                                getRowId={(row) => row.id || observationEditData.indexOf(row)}
                                                                components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                                pagination
                                                                paginationMode="client"
                                                                rowsPerPageOptions={[25, 50, 100]}
                                                                pageSize={pageSize6}
                                                                onPageSizeChange={(newPageSize) => setPageSize6(newPageSize)}
                                                                getRowHeight={() => 'auto'}

                                                                sx={{
                                                                    '& .MuiDataGrid-iconSeparator': {
                                                                        display: 'none',
                                                                    },

                                                                    '& .MuiDataGrid-virtualScroller': {
                                                                        overflowX: 'hidden !important',
                                                                    },
                                                                }}


                                                            />
                                                        </div>

                                                    </Box>

                                                    {/* Sticky Footer */}
                                                </Box>
                                            </Box>
                                        </Modal>


                                        <Box />
                                        <Stack direction={{ xs: "column", sm: "row" }} spacing={4} >
                                            <FormControl fullWidth size="small">
                                                <FormLabel >Delivery Time</FormLabel>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    type="number"
                                                    value={deliveryTime}
                                                    onChange={handleDeliveryTime}
                                                    placeholder='Delivery Time'
                                                />
                                            </FormControl>
                                            <FormControl fullWidth size="small">
                                                <FormLabel >Sub Status</FormLabel>
                                                <Autocomplete
                                                    fullWidth

                                                    size="small"
                                                    id="subStatus"
                                                    value={selectedSubStatus.find((option) => option.Id === subStatus) || ""}
                                                    onChange={(_, newValue) => handleSubStatus(newValue)}
                                                    options={selectedSubStatus}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    renderInput={(params) => <TextField {...params} placeholder="Select Sub Status" />}
                                                    limitTags={2}
                                                />
                                            </FormControl>

                                        </Stack>
                                        <FormGroup>
                                            <FormControlLabel
                                                sx={{ width: '150px' }}
                                                control={
                                                    <Checkbox
                                                        checked={isCheck}
                                                        onChange={handleStatusCheckbox}
                                                        icon={
                                                            <Box
                                                                sx={{
                                                                    width: 18,
                                                                    height: 18,
                                                                    border: '1px solid #D1D5DB',
                                                                    borderRadius: '4px',
                                                                }}
                                                            />
                                                        }
                                                        checkedIcon={
                                                            <Box
                                                                sx={{
                                                                    width: 18,
                                                                    height: 18,
                                                                    border: '1px solid #D1D5DB',
                                                                    borderRadius: '4px',
                                                                    backgroundColor: '#1976d2',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: '#fff',
                                                                    fontSize: 14,
                                                                }}
                                                            >
                                                                ✓
                                                            </Box>
                                                        }
                                                    />
                                                }
                                                label="Include In Call List"
                                            />
                                        </FormGroup>


                                        <Stack direction={{ xs: "column", sm: "row" }} spacing={4} alignItems="center">
                                            <FormControl fullWidth size="small">
                                                <FormLabel>Issue Remark</FormLabel>

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        borderRadius: "8px",
                                                        backgroundColor: "#FDF2F8",
                                                        border: '1px solid #FCCEE8',
                                                        px: 2,
                                                        py: 1,
                                                    }}
                                                >
                                                    <Typography variant="body2" sx={{ fontWeight: 500 }} dangerouslySetInnerHTML={{ __html: statusRemark }} />

                                                </Box>

                                            </FormControl>

                                        </Stack>

                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} alignItems="center" width="100%">
                                            <FormControl fullWidth>
                                                <Box >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            mb: '-17px',
                                                        }}
                                                    >
                                                        <FormLabel sx={{ mb: 0 }}>Remark</FormLabel>

                                                        <Box>
                                                            <IconButton size="small" color="primary" onClick={handelOpenClick}>
                                                                <ModeEditOutlineOutlinedIcon sx={{ fontSize: 16 }} />

                                                            </IconButton>
                                                            <IconButton size="small" color="primary" onClick={handeltrackerDetailsOpenClick}>
                                                                <ReorderOutlinedIcon sx={{ fontSize: 16 }} />
                                                            </IconButton>
                                                        </Box>


                                                    </Box>
                                                </Box>

                                                <Modal open={openModal} onClose={handleCloseModal}>
                                                    <Box
                                                        sx={modalStyle}

                                                    >
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '10px 16px',
                                                                borderBottom: '1px solid #E0E0E0',
                                                                backgroundColor: '#fff',
                                                                m: 0, // remove outer margins
                                                            }}
                                                        >
                                                            <Typography variant="h6" fontWeight="bold">Remark</Typography>
                                                            <IconButton onClick={handleCloseModal}>
                                                                <Icon icon="mdi:close" />
                                                            </IconButton>
                                                        </Box>

                                                        <Box sx={{ px: 2, pt: 2 }}>
                                                            <Stack spacing={1.5}>
                                                                {/* Client Remark */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>Client remark </FormLabel>
                                                                    <TextareaAutosize
                                                                        minRows={3}
                                                                        placeholder="Client Remark"
                                                                        value={clientRemark}
                                                                        onChange={handleClientRemark}
                                                                        style={{ overflow: 'auto', }}
                                                                    />
                                                                </FormControl>
                                                                {/* Site Remark */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>Site remark </FormLabel>
                                                                    <TextareaAutosize
                                                                        minRows={3}
                                                                        placeholder="Site Remark"
                                                                        value={siteRemark}
                                                                        onChange={handleSiteRemark}
                                                                        style={{ overflow: 'auto', }}

                                                                    />
                                                                </FormControl>

                                                                {/* Client + Site Remark */}
                                                                <FormControl size="small" fullWidth>
                                                                    <FormLabel>Client - Site remark </FormLabel>
                                                                    <TextareaAutosize
                                                                        minRows={3}
                                                                        placeholder="Client + Site Remark"
                                                                        value={clientSiteRemark}
                                                                        onChange={handleClientSiteRemark}
                                                                        style={{ overflow: 'auto', }}

                                                                    />
                                                                </FormControl>

                                                            </Stack>
                                                        </Box>
                                                        {/* Save and Cancel Buttons */}
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'flex-end',
                                                                gap: 1.5,
                                                                px: 2,
                                                                py: 1.5,

                                                                mt: 2,
                                                            }}
                                                        >
                                                            <Button
                                                                size="medium"
                                                                type="submit"
                                                                variant="contained"
                                                                sx={{ color: "white" }}
                                                                onClick={handleStatusRemarkSave}
                                                            >
                                                                Save
                                                            </Button>

                                                        </Box>
                                                    </Box>
                                                </Modal>

                                                <Modal open={openTrcakerDetailsModal} onClose={handleCloseTrackerDetailsModal}>
                                                    <Box sx={modalStyle}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '10px 16px',
                                                                borderBottom: '1px solid #E0E0E0',
                                                                backgroundColor: '#fff',
                                                                m: 0, // remove outer margins
                                                            }}
                                                        >
                                                            <Typography variant="h6" fontWeight="bold"> Tracker Details</Typography>
                                                            <IconButton onClick={handleCloseTrackerDetailsModal}>
                                                                <Icon icon="mdi:close" />
                                                            </IconButton>
                                                        </Box>
                                                        <div style={{ height: '62vh', width: '100%' }}>
                                                            <DataGrid
                                                                rows={trackerDetailsData}
                                                                columns={trackerDetailsColumn}
                                                                density="compact"
                                                                getRowId={(row) => row.id || trackerDetailsData.indexOf(row)}
                                                                getRowHeight={() => 'auto'}
                                                                components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                                pagination
                                                                paginationMode="client"
                                                                rowsPerPageOptions={[25, 50, 100]}
                                                                pageSize={pageSize}
                                                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                                            />
                                                        </div>

                                                    </Box>
                                                </Modal>
                                                {/* Text Area with Toolbar (Read-Only) */}
                                                <TextAreaWithToolbar
                                                    value={combinedRemarks || ''}
                                                    placeholder="Enter detailed remarks about the issue..."
                                                    toolbarId="toolbar1"
                                                    isEditable="true"
                                                    showToolbar={false}
                                                    minHeight={100}
                                                />
                                            </FormControl>
                                        </Stack>


                                    </Stack>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    px: 2,
                                    pb: 1,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: 2,
                                    backgroundColor: 'white', // prevent overlap while scrolling
                                }}
                            >
                                <Button variant="outlined" color="inherit" onClick={handleStatusReset}>
                                    Reset
                                </Button>
                                <Button variant="contained" sx={{ color: 'white' }} onClick={handleSaveStatusClick}>
                                    Save Status
                                </Button>
                            </Box>
                        </Box>
                    </Grid>


                    <Grid item xs={12} sm={5.9} >
                        <Box
                            sx={{
                                height: '78vh',
                                display: 'flex',
                                flexDirection: 'column',
                                border: "1px solid #E5E5E5",
                                borderRadius: "8px",
                                overflow: 'hidden', // hide scrollbars from main box
                                backgroundColor: '#FFFFFF',

                            }}
                        >

                            <Box
                                sx={{
                                    flex: 1,
                                    overflowY: 'auto',
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        px: 2,
                                        py: 1.5,
                                        backgroundColor: '#FFFFFF',
                                    }}
                                >
                                    {/* Left side: Icon + Title */}
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PersonAddAlt1OutlinedIcon
                                            sx={{ color: '#4A5565', mr: 1, width: 20, height: 20 }}
                                        />
                                        <Typography sx={{ fontSize: 14, color: '#121212', fontWeight: 600 }}>
                                            Issue Allocation
                                        </Typography>
                                    </Box>


                                </Box>

                                <Box sx={{ px: 2, pb: 2 }}>
                                    <Stack >

                                        <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>

                                            <FormControl
                                                size="small"
                                                fullWidth
                                            >
                                                <FormLabel>Executive</FormLabel>

                                                <Select
                                                    label="executive"
                                                    size="small"
                                                    value={executive}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                backgroundColor: '#fbe9e7',
                                                                maxHeight: '200px',
                                                                width: '200px',
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e) => handleExecutive(e.target.value)}
                                                >
                                                    {selectedExecutive.map((exc) => (
                                                        <MenuItem key={exc.Id} value={exc.Id}>
                                                            {exc.Name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>

                                            </FormControl>

                                            <FormControl fullWidth size="small">
                                                <FormLabel >Project</FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    id="project"
                                                    value={selectedProject.find(option => option.ProjectVersionId === project) || ""}
                                                    onChange={(_, newValue) => handleProject(newValue)}
                                                    options={selectedProject}
                                                    getOptionLabel={(option) => option.ProjectVersionName || ""}
                                                    renderInput={(params) => <TextField {...params} placeholder="Select Project" />}
                                                />

                                            </FormControl>

                                        </Stack>
                                        <Box
                                            sx={{
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 5,
                                                backgroundColor: 'white',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                width: '100%',
                                                py: 1, // optional padding for spacing
                                            }}
                                        >

                                            {/* Left side: Icon + Title */}
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Icon icon="mdi:calendar-clock-outline" style={{ width: 16, height: 16, marginRight: 8, color: '#4A5565' }} />
                                                <Typography variant="h6" fontSize='12px' fontWeight='500'>Scheduling</Typography>

                                            </Box>

                                            {/* Right side: Right-aligned link */}
                                            <Box sx={{ textAlign: 'right' }}>

                                                <Button
                                                    onClick={handleAppointmentOpenModal}
                                                    variant="contained"
                                                    color="secondary"
                                                    startIcon={
                                                        <Icon
                                                            icon="material-symbols:pace"
                                                            style={{ fontSize: 20 }}
                                                        />
                                                    }
                                                    sx={{
                                                        fontSize: 12, // set button text font size
                                                        textTransform: 'none', // optional: prevent uppercase
                                                        height: 28,
                                                        backgroundColor: '#1579FC',

                                                    }}
                                                >
                                                    {selectedDate
                                                        ? Moment(selectedDate).format("DD-MMM-YYYY hh:mm A")
                                                        : "Set Appointment"}
                                                </Button>
                                                <Modal open={questionnaireModal} onClose={handelQuestionnaireCancelClick}>
                                                    <Box sx={modalStyle}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '10px 16px',
                                                                borderBottom: '1px solid #E0E0E0',
                                                                backgroundColor: '#fff',
                                                                m: 0, // remove outer margins
                                                            }}
                                                        >
                                                            <IconButton
                                                                onClick={handelQuestionnaireCancelClick}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '10px',
                                                                    right: '10px',
                                                                    color: 'grey',
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                            <Typography variant="h6" color="#E7000B" mb={1}>
                                                                Appointment Date Change Reason
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ px: 2, pt: 2, pb: 2 }}>

                                                            <Stack spacing={3}>
                                                                <Stack direction="row" spacing={2} mt={4}>

                                                                    <Typography variant="h6" mb={1}>
                                                                        {questionnaireTxt}
                                                                    </Typography>

                                                                    <FormControl size="small" fullWidth>
                                                                        <Select
                                                                            size="small"
                                                                            value={questionnaire} // This value should match the selected option
                                                                            onChange={handleQuestionnaire} // Use the onChange directly to set the value
                                                                            MenuProps={{
                                                                                PaperProps: {
                                                                                    sx: {
                                                                                        backgroundColor: '#fbe9e7',
                                                                                        maxHeight: '200px',
                                                                                        width: '200px', // Set the max height here
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            {selectedQuestionnaire.map((reason) => (
                                                                                <MenuItem key={reason.Id} value={reason.Id}> {/* Removed onClick */}
                                                                                    {reason.Value}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                </Stack>

                                                                {/* Save and Cancel Buttons */}
                                                                <Stack direction="row" justifyContent="center" spacing={2} mt={4}>
                                                                    <Button
                                                                        size="medium"
                                                                        type="submit"
                                                                        variant="contained"
                                                                        sx={{ color: "white" }}
                                                                        onClick={handelQuestionnaireCancelClick}
                                                                    >
                                                                        Save
                                                                    </Button>

                                                                </Stack>
                                                            </Stack>
                                                        </Box>

                                                    </Box>
                                                </Modal>

                                                <Modal open={openAppointmentModal} onClose={handleAppointemntCloseModal}>
                                                    <Box sx={style}>

                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '10px 16px',
                                                                borderBottom: '1px solid #E0E0E0',
                                                                backgroundColor: '#fff',
                                                                m: 0, // remove outer margins
                                                            }}
                                                        >
                                                            <Typography variant="h6" fontWeight='bold'>
                                                                Set Appointment
                                                            </Typography>

                                                            <IconButton
                                                                onClick={handleAppointemntCloseModal}
                                                                sx={{
                                                                    color: 'grey',
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Box>
                                                        <Stack spacing={3} sx={{ p: 2 }}>
                                                            <Stack
                                                                direction="row"
                                                                spacing={2}
                                                                alignItems="flex-end"
                                                                justifyContent="space-between"
                                                                flexWrap="wrap"
                                                            >
                                                                <FormControl sx={{ flex: 1 }} size="small">
                                                                    <FormLabel>Appointment Date</FormLabel>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            inputFormat="dd/MMM/yyyy"
                                                                            value={Moment(appointmentDateTime, 'DD-MMM-YYYY').toDate()}
                                                                            onChange={handleAppointmentDateTime}
                                                                            renderInput={(params) => (
                                                                                <TextField fullWidth size="small" {...params} error={false} />
                                                                            )}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </FormControl>

                                                                {/* Time */}
                                                                <FormControl sx={{ flex: 1 }} size="small">
                                                                    <FormLabel>Appointment Time</FormLabel>
                                                                    <TextField
                                                                        value={appointmentTime ? Moment(appointmentTime, 'hh:mm A').format('HH:mm') : ''}
                                                                        onChange={handleAppointmentTime}
                                                                        type="time"
                                                                        InputLabelProps={{ shrink: true }}
                                                                        inputProps={{ step: 300 }}
                                                                        size="small"
                                                                        fullWidth
                                                                    />
                                                                </FormControl>
                                                                <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                                                                    <Button
                                                                        size="medium"
                                                                        variant="contained"
                                                                        sx={{ color: "white" }}
                                                                        onClick={handleAppointmentSave}
                                                                    >
                                                                        Save
                                                                    </Button>
                                                                    {showTentativeSupport && (
                                                                        <Button
                                                                            size="medium"
                                                                            variant="contained"
                                                                            sx={{ color: "white", height: 40 }}
                                                                            onClick={handleTentativeSupport}
                                                                        >
                                                                            Tentative Support
                                                                        </Button>
                                                                    )}
                                                                </Stack>
                                                            </Stack>
                                                            {error && (
                                                                <Typography color="error" variant="body2">
                                                                    {error}
                                                                </Typography>
                                                            )}
                                                            {showTentativeSupport && (

                                                                <Stack direction="row" spacing={2} alignItems="center">
                                                                    <div style={{ height: '60vh', width: '100%' }}>
                                                                        <DataGrid
                                                                            rows={availableSlotsData}
                                                                            columns={availableSlotsDataColumn}
                                                                            density="compact"
                                                                            getRowId={(row) => row.SlotDate}
                                                                            components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                                            pagination
                                                                            paginationMode="client"
                                                                            rowsPerPageOptions={[25, 50, 100]}
                                                                            pageSize={pageSize1}
                                                                            onPageSizeChange={(newPageSize) => setPageSize1(newPageSize)}
                                                                            getRowHeight={() => 'auto'}
                                                                            sx={{

                                                                                '& .MuiDataGrid-iconSeparator': {
                                                                                    display: "none", // Removes the separator
                                                                                },
                                                                                '& .MuiDataGrid-row:nth-of-type(even)': {
                                                                                    backgroundColor: 'white', // Even rows: White
                                                                                },
                                                                                '& .MuiDataGrid-row:nth-of-type(odd)': {
                                                                                    backgroundColor: '#f5f3f2', // Odd rows: Blue
                                                                                    color: 'bleck', // Set text color to white for better contrast
                                                                                },
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Stack>
                                                            )}

                                                        </Stack>
                                                    </Box>
                                                </Modal>

                                            </Box>
                                        </Box>

                                        <Stack direction={{ xs: "column", sm: "row" }} spacing={4} alignItems="center">
                                            <FormControl fullWidth>
                                                {/* Top Row: Label + Icons */}
                                                <FormLabel sx={{ mb: '-17px' }} >Remark</FormLabel>
                                                {/* Text Area with Toolbar */}
                                                <TextAreaWithToolbar
                                                    onChange={handleIssueAllocationRemark}
                                                    value={remarkIssueAllocation}
                                                    placeholder="Enter detailed remarks about the issue..."
                                                    toolbarId="toolbar2"
                                                    isEditable="true"
                                                />
                                            </FormControl>

                                        </Stack>
                                        <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>
                                            <FormControl fullWidth size="small">
                                                <FormLabel >Activity Type</FormLabel>
                                                <Autocomplete
                                                    fullWidth

                                                    size="small"
                                                    id="activitytype"
                                                    value={selectedActivity.find((option) => option.Id === activity) || ""}
                                                    onChange={(_, newValue) => handleActivity(newValue)}
                                                    options={selectedActivity}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    renderInput={(params) => <TextField {...params} placeholder="Select Activity Type" />}
                                                    limitTags={2}
                                                />
                                            </FormControl>

                                            <FormControl fullWidth size="small">
                                                <FormLabel >Estimated Time</FormLabel>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    type="number"
                                                    sx={{ flex: 1 }}
                                                    placeholder="Enter estimated time in minutes"
                                                    value={estimatedTime}
                                                    onChange={handleEstimatedTime}
                                                />
                                            </FormControl>

                                        </Stack>
                                        <Stack direction="row" spacing={2} alignItems="flex-end" mt={1}>
                                            <FormControl fullWidth size="small">
                                                <FormLabel >Allocation Reason</FormLabel>
                                                <Autocomplete
                                                    size="small"
                                                    id="allocation-reason"
                                                    value={(Array.isArray(selectedAllocationReason)
                                                        ? selectedAllocationReason.find(option => option.Id === allocationReason)
                                                        : null) || null}
                                                    onChange={(_, newValue) => handleAllocationReason(newValue)}
                                                    options={selectedAllocationReason}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth placeholder='Select Reason'
                                                        />

                                                    )}
                                                />
                                            </FormControl>

                                            {Array.isArray(selectedAllocationReason) &&
                                                selectedAllocationReason.find(item => item.Id === allocationReason)?.ExpectedTime === 0 && (

                                                    <Tooltip title="Observation">
                                                        <Button variant="contained" color='secondary' size="small" onClick={handleObservationModal} sx={{ minWidth: '40px', height: '32px' }}>
                                                            <Icon icon="ic:baseline-plus" width="20px" height="20px" />
                                                        </Button>
                                                    </Tooltip>
                                                )}

                                            {/* {Array.isArray(observationEditData) && observationEditData.length > 0 && ( */}
                                            <Stack direction="row" justifyContent="flex-end">

                                                <Tooltip title="Observation History">
                                                    <Button variant="contained" color='inherit' size="small" onClick={handleObservationHistoryOpenClick} sx={{
                                                        minWidth: '40px', height: '32px',
                                                    }}>
                                                        <Icon icon="material-symbols:history-rounded" width="20px" height="20px" />
                                                    </Button>

                                                </Tooltip>
                                            </Stack>
                                            {/* )} */}

                                        </Stack>

                                    </Stack>
                                </Box>
                            </Box>
                            <Box
                                sx={{

                                    px: 2,
                                    pb: 1,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: 2,
                                    backgroundColor: 'white', // prevent overlap while scrolling
                                }}
                            >
                                <Button variant="outlined" color="inherit" onClick={hnadleIssueAllocationReset}>
                                    Reset
                                </Button>
                                <LoadingButton
                                    size="medium"
                                    type="submit"
                                    variant="contained"
                                    sx={{ color: 'white' }}
                                    onClick={handleSaveAllocationClick}

                                >
                                    Save Issue
                                </LoadingButton>
                            </Box>
                        </Box>

                    </Grid>
                </Grid>
            )}



            {openModalForCancel && <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />}
            {openModalForSaveStatus && (<ModalPopUp openCloseValue={setOpenModalForSaveStatus} msg="Are you sure you want to save the Status ?" confirm={handleSaveStatusConfirm} />)}
            {openModalForSaveAllocation && (<ModalPopUp openCloseValue={setOpenModalForSaveAllocation} msg="Are you sure you want to save the issue allocation ?" confirm={handleSaveAllocationConfirm} />)}

            {loading && (<LoadingProgressBar sx={{ py: 6 }} />)}

        </>
    );
}